import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ReportMetaData } from '../../reports/report';
import { environment } from '../../../environments/environment';
import { ContactsReportData, Page } from '../shared/models/Contact';

@Injectable()
export class ContactsReports {
  constructor(private http: HttpClient) {}

  getContactsReport(reportParams: ContactsReportData): Observable<any> {
    return this.http.post<any>(
      `${
        document.location.origin === environment.CHANNELS_URL
          ? environment.BACKEND_CHANNELS_URL
          : environment.BASE_BACKEND_URL
      }/record-events/report`,
      reportParams,
      {
        responseType: 'blob' as 'json'
      }
    );
  }
}
